import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AdminAlert } from '../models/site-review/admin-alert.model';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class AlertService {
  public sessionId: string;
  public apiServer: string = '';

  constructor(private _http: HttpClient) {
    this.apiServer = environment.siteReviewURL;
    this.sessionId = localStorage.getItem("sr_session_id");
  }
  
  getAlerts(startDate?: string, endDate?: string): Observable<AdminAlert[]> {
    let url = this.apiServer + "/api/alerts/?sid=" + this.sessionId;
    if (startDate && endDate) {
      url += `&start=${startDate}&end=${endDate}`;
    }
    return this._http.get<AdminAlert[]>(url);
  }

  getById(alertId: number): Observable<AdminAlert> {
    let url = this.apiServer + "/api/alerts/" + alertId + "?sid=" + this.sessionId;
    return this._http.get<AdminAlert>(url);
  }

  async save(alertId: number, payload: AdminAlert): Promise<Observable<any>> {
    let url = this.apiServer + "/api/alerts/" + alertId + "?sid=" + this.sessionId;
    return this._http.put(url, payload);
  }

  async add(payload: AdminAlert): Promise<Observable<any>> {
    let url = this.apiServer + "/api/alerts/?sid=" + this.sessionId;
    return this._http.post(url, payload);
  }

  async delete(alertId: number): Promise<Observable<any>> {
    let url = this.apiServer + "/api/alerts/" + alertId + "?sid=" + this.sessionId;
    return this._http.delete(url);
  }

  acknowledgement(alertId: number): Observable<any> {
    let url = this.apiServer + "/api/alerts/" + alertId + "/acknowledge?sid=" + this.sessionId;
    return this._http.post(url, {});
  }

  getOutstandingAlerts(): Observable<AdminAlert[]> {
    let url = this.apiServer + "/api/alerts/outstanding?sid=" + this.sessionId;
    return this._http.get<AdminAlert[]>(url);
  }
}
